import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { BASE_URL } from "../../api/endpoints";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setBrand, setFilter } from "../../redux/slice/Slice";
import { useDashboard } from "../../common/Sidecontext";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

function PremiumFranchise({ data }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { dashboardRef } = useDashboard();
  const [hoveredItemIndex, setHoveredItemIndex] = useState(null);
  const handleMouseEnter = (index) => setHoveredItemIndex(index);
  const handleMouseLeave = () => setHoveredItemIndex(null);
  const item = data?.slice(0, 4)

  const mainCarouselItems = item?.map((item, index) => (
    <div className={`"bg-[#f9f8f8] !bg-[#f9f8f8] my-3 rounded-md overflow-hidden p-3 lg:p-0 hover:[box-shadow:0px_14px_20px_0px_#0000001A] mx-2 ${data?.length === 1 || item?.length === 2 ? "max-w-[300px]" : "max-w-[x]"}`} key={index} onMouseEnter={() => handleMouseEnter(index)}
      onMouseLeave={handleMouseLeave}>
      <div className="relative overflow-hidden bg-cover flex justify-center items-center">
        <img
          className="w-full h-36 border border-gray-200 rounded-md hover:scale-110 transition-all duration-300 ease-in-out cursor-pointer"
          src={`${item?.upload_logo}`}
          alt="Denzfox"
        />
      </div>
      {/* Hover Carousel */}
      {/* {hoveredItemIndex === index && (
        <div className="absolute inset-0 bg-opacity-90 flex items-center justify-center rounded-md h-36 ">
          <AliceCarousel
            mouseTracking
            items={data?.map((item, i) => (
              <div className="max-w-[380px] mx-auto h-[150px] mt-3">
                <img
                  key={i}
                  className="h-[150px] w-full rounded-md"
                  src={item.upload_banner}
                  alt={`Hover-${i}`}
                />
              </div>
            ))}
            autoPlay
            infinite
            autoPlayInterval={1000}
            disableDotsControls
            disableButtonsControls
          />
        </div>
      )} */}
      <div className="py-2 px-0">
        <p className="text-sm text-gray-600">{item?.category?.name}</p>
        <h3 className="text-xl font-semibold text-gray-800 2xl:w-[300px] lg:w-[200px] h-[42px] overflow-hidden overflow-ellipsis whitespace-nowrap">
          {item?.brand_name}
        </h3>
        <div className="xl:min-h-[100px]">
          <div className="flex justify-between text-sm text-gray-600 mb-[10px]">
            <p className="flex-[0_0_50%] whitespace-nowrap">Investment Range</p>
            <p className="font-bold text-start 2xl:flex-[0_0_50%]  flex-[0_0_35%] w-[200px] overflow-hidden overflow-ellipsis whitespace-nowrap">{item?.investment}</p>
          </div>
          <div className="flex justify-between text-sm text-gray-600 mb-[10px]">
            <p className="flex-[0_0_50%] whitespace-nowrap">Area Required</p>
            <p className="font-bold text-start 2xl:flex-[0_0_50%]  flex-[0_0_35%] w-[200px] overflow-hidden overflow-ellipsis whitespace-nowrap">{item?.required_area}</p>
          </div>
          <div className="flex justify-between text-sm text-gray-600 mb-[10px]">
            <p className="flex-[0_0_50%] whitespace-nowrap">Franchise Outlets</p>
            <p className="font-bold text-start 2xl:flex-[0_0_50%]  flex-[0_0_35%] w-[200px] overflow-hidden overflow-ellipsis whitespace-nowrap">{item?.brand_outlet}</p>
          </div>
        </div>
        <div className="border-2 rounded-md border-gray-600 mt-1 text-center text-sm text-gray-800 py-2 cursor-pointer button button4">
          <p
            className=""
            onClick={() => { dispatch(setFilter(data)); navigate(`/franchise-opportunity/${item?.brand_url}`, { state: { item: item } }) }
            }
          >
            Explore
            <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
          </p>
        </div>
      </div>
    </div>
  ));

  return (
    <div ref={dashboardRef} className="w-full max-w-[1250px]     mx-auto xl:px-0 lg:px-0 md:px-5 px-4">
      <div className="mb-5 mt-5 max-sm:!mb-3 !mt-3">
        <h1 className="text-start font-bold 2xl:text-[32px] xl:text-[32px] lg:text-[32px] md:text-4xl text-2xl xl:mb-5 lg:mb-5 md:mb-5 mb-3 ">
          Premium{" "}
          <span className="text-secondaryColor">Franchise Opportunities</span>
        </h1>
        <hr />
      </div>
      <div className={`${item?.length === 1 || item?.length === 2 || item?.length === 3 ? "Carsouleitemwidth" : ""}`}>
        {item?.length === 1 || item?.length === 2 || item?.length === 3 ?
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 sm:gap-5 mx-auto md:gap-2-important lg:gap-0-important xl:gap-0-important gap-4">
            {item?.map((item, index) => (
              <div
                key={index}
                className={`bg-[#f9f8f8]  my-3 rounded-md overflow-hidden p-3 lg:p-0 hover:[box-shadow:0px_14px_20px_0px_#0000001A] mx-2 ${data?.length === 1 || item?.length === 2 ? "max-w-[300px]" : "max-w-[x]"}`}
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={handleMouseLeave}
              >
                <div className="relative overflow-hidden bg-cover flex justify-center items-center">
                  <img
                    className="w-full h-36 border border-gray-200 rounded-md hover:scale-110 transition-all duration-300 ease-in-out cursor-pointer"
                    src={`${item?.upload_logo}`}
                    alt="Denzfox"
                  />
                </div>
                {/* Hover Carousel */}
                {/* {hoveredItemIndex === index && (
        <div className="absolute inset-0 bg-opacity-90 flex items-center justify-center rounded-md h-36 ">
          <AliceCarousel
            mouseTracking
            items={data?.map((item, i) => (
              <div className="max-w-[380px] mx-auto h-[150px] mt-3">
                <img
                  key={i}
                  className="h-[150px] w-full rounded-md"
                  src={item.upload_banner}
                  alt={`Hover-${i}`}
                />
              </div>
            ))}
            autoPlay
            infinite
            autoPlayInterval={1000}
            disableDotsControls
            disableButtonsControls
          />
        </div>
      )} */}
                <div className="py-2 px-0">
                  <p className="text-sm text-[#0C5399]">{item?.category?.name}</p>
                  <h3 className="text-xl font-semibold text-gray-800 2xl:w-[300px] lg:w-[200px] h-[42px] overflow-hidden overflow-ellipsis whitespace-nowrap">
                    {item?.brand_name}
                  </h3>
                  <div className="xl:min-h-[100px]">
                    <div className="flex justify-between text-sm text-gray-600 mb-[10px]">
                      <p className="flex-[0_0_50%] whitespace-nowrap">Investment Range</p>
                      <p className="font-bold text-start 2xl:flex-[0_0_50%]  flex-[0_0_35%] w-[200px] overflow-hidden overflow-ellipsis whitespace-nowrap">{item?.investment}</p>
                    </div>
                    <div className="flex justify-between text-sm text-gray-600 mb-[10px]">
                      <p className="flex-[0_0_50%] whitespace-nowrap">Area Required</p>
                      <p className="font-bold text-start 2xl:flex-[0_0_50%]  flex-[0_0_35%] w-[200px] overflow-hidden overflow-ellipsis whitespace-nowrap">{item?.required_area}</p>
                    </div>
                    <div className="flex justify-between text-sm text-gray-600 mb-[10px]">
                      <p className="flex-[0_0_50%] whitespace-nowrap">Franchise Outlets</p>
                      <p className="font-bold text-start 2xl:flex-[0_0_50%]  flex-[0_0_35%] w-[200px] overflow-hidden overflow-ellipsis whitespace-nowrap">{item?.brand_outlet}</p>
                    </div>
                  </div>
                  <div className="border-2 rounded-md border-gray-600 mt-1 text-center text-sm text-gray-800 py-2 cursor-pointer button button4">
                    <p
                      className=""
                      onClick={() => { dispatch(setFilter(data)); navigate(`/franchise-opportunity/${item?.brand_url}`, { state: { item: item } }) }
                      }
                    >
                      Explore
                      <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
                    </p>
                  </div>
                </div>
              </div>
            ))
            } </div> : (
            <AliceCarousel
              mouseTracking
              autoPlay
              infinite
              items={mainCarouselItems}
              autoPlayInterval={2000}
              disableDotsControls
              disableButtonsControls
              responsive={{
                0: { items: 1 },
                768: { items: 2 },
                1024: { items: 3 },
                1280: { items: 4 },
              }}
            />
          )}


      </div>

      <div className="flex justify-center items-center 2xl:mt-5 xl:mt-5 md:mt-5 mt-2">
        <div
          className="border-2 border-[#4A5661] bg-[#4A5661] text-white border-gray-600 text-center text-sm text-gray-800 py-2  w-60 rounded-md 2xl:mt-[50px] xl:mt-[50px] lg:mt-[50px] md:mt-[50px] mt-[30px] cursor-pointer hover:[box-shadow:0_0_10px_0_#4a5661_inset,_0_0_20px_2px_#4a5661]"
          onClick={() => {
            navigate(`/products/best-bussinessdetails`, { state: { item: data } });
            dispatch(setFilter(data));
            dispatch(setBrand("Premium Franchise Opportunities"));

          }}
        >
          <p className="">
            VIEW ALL
            <FontAwesomeIcon icon={faArrowRight} className="ml-1" />
          </p>
        </div>
      </div>
    </div>
  );
}

export default PremiumFranchise;
